import React, { useEffect, useState } from 'react';
// import Select from 'react-select'; // Not needed for this simple form
import AppBreadCrumb from '../../common/AppBreadCrumb'; // Corrected path
import { createHoa, fetchHoa, updateHoa } from '../../../api/HoasAPI'; // Corrected path
import { handleApiError } from '../../../api/risapi'; // Corrected path
import AppToaster from '../../AppToaster'; // Corrected path
import { useNavigate, useParams } from 'react-router-dom'; // Added useParams
import { capitalizeFirstLetter } from '../../../commonfunctions'; // Corrected path

// Props definition directly in function signature
const HoasForm = ({ formType, currentHoaId }) => {
    const navigate = useNavigate();
    // Removed unused formRef

    const [currentHoa, setCurrentHoa] = useState({ name: '' }); // Simplified initial state
    const [currentHoaError, setCurrentHoaError] = useState({});
    // Removed roles state

    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});
    const [loading, setLoading] = useState(false); // Added loading state
    // Removed selectedRoles state

    // Fetch data only in edit mode
    useEffect(() => {
        // Reset form on type/id change
        setCurrentHoa({ name: '' });
        setCurrentHoaError({});

        if (formType === 'edit' && currentHoaId) {
            setLoading(true);
            fetchHoa(currentHoaId, function (response) {
                setLoading(false);
                if (response.hoa) {
                    // Set only the relevant fields for the form
                    setCurrentHoa({
                         id: response.hoa.id, // Keep ID for update
                         name: response.hoa.name,
                         is_system_defined: response.hoa.is_system_defined, // For display logic
                         is_gst_head: response.hoa.is_gst_head // For display logic
                    });
                } else {
                     handleApiError(response, () => {}); // Use dummy setter if needed
                     setToaster({ type: 'danger', heading: 'Error', message: 'Could not load Head of Account.' });
                     setShowToaster(true);
                     // Optionally navigate back or show a clear error state
                     navigate('/franchisee_user/masters/hoas'); // Navigate back on error
                }
            });
        }
    }, [formType, currentHoaId, navigate]); // Added navigate to dependency array

    const saveAddHoaForm = (exitForm) => {
        setCurrentHoaError({});
        setLoading(true);
        // Send only the name for creation
        const saveHoaData = { name: currentHoa.name };

        createHoa(saveHoaData, function (response) { // Use saveHoaData
            setLoading(false);
            if (response.hoa) {
                if (exitForm) {
                    navigate('/franchisee_user/masters/hoas', { state: { message: 'Head of Account saved successfully!' } });
                } else {
                    // Reset form for "Save + Next"
                    setCurrentHoa({ name: '' });
                    setToaster({ type: 'success', heading: 'Success', message: 'Head of Account Added Successfully' });
                    setShowToaster(true);
                }
            } else {
                handleApiError(response, setCurrentHoaError);
                setToaster({ type: 'danger', heading: 'Error', message: 'Could not save Head of Account.' });
                setShowToaster(true);
            }
        });
    };

    const saveEditHoaForm = (exitForm) => {
        // Prevent editing name if system-defined (UI should ideally disable input too)
        if (currentHoa?.is_system_defined) {
             setToaster({ type: 'warning', heading: 'Read Only', message: 'System-defined Heads of Account cannot be modified.' });
             setShowToaster(true);
             // Optionally navigate back immediately
             if (exitForm) {
                 navigate('/franchisee_user/masters/hoas');
             }
             return; // Stop the save process
        }


        setCurrentHoaError({});
        setLoading(true);
        // Send only ID and name for update
        const updateHoaData = { id: currentHoa.id, name: currentHoa.name };

        updateHoa(updateHoaData, function (response) { // Use updateHoaData
            setLoading(false);
            if (response.hoa) {
                navigate('/franchisee_user/masters/hoas', { state: { message: 'Head of Account updated successfully!' } });
            } else {
                handleApiError(response, setCurrentHoaError);
                 setToaster({ type: 'danger', heading: 'Error', message: 'Could not update Head of Account.' });
                 setShowToaster(true);
            }
        });
    };

    const handleResetHoaForm = () => {
         if (formType === 'create') {
            setCurrentHoa({ name: '' });
            setCurrentHoaError({});
         } else if (currentHoaId){
             // Re-fetch data for edit mode reset
             setLoading(true);
             fetchHoa(currentHoaId, function (response) {
                 setLoading(false);
                 if (response.hoa) {
                     setCurrentHoa({
                          id: response.hoa.id,
                          name: response.hoa.name,
                          is_system_defined: response.hoa.is_system_defined,
                          is_gst_head: response.hoa.is_gst_head
                     });
                     setCurrentHoaError({}); // Clear errors
                 } else {
                      setToaster({ type: 'danger', heading: 'Error', message: 'Could not reload data.' });
                      setShowToaster(true);
                 }
             });
         }
    };

    const getTitle = () => {
        return formType === 'create' ? 'Create New Head of Account' : 'Edit Head of Account';
    };

    const isReadOnly = formType === 'edit' && currentHoa?.is_system_defined;


    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title={getTitle()}>
                        <li><a className="f-s-14 f-w-500" href="#">Masters</a></li>
                        <li><a className="f-s-14 f-w-500" href="/franchisee_user/masters/hoas">Heads of Account</a></li> {/* Corrected Link */}
                        <li className="active"><a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a></li>
                    </AppBreadCrumb>

                    {loading && <div className="loader_box"><div className="loader_14"></div></div>}

                    {!loading && (
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>{formType === 'create' ? 'Add New' : 'Edit'} Head of Account {formType === 'edit' ? `: ${currentHoa?.name || ''}` : ''}</h5>
                                    </div>
                                    <div className="card-body">
                                        <form className="app-form" onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label"> Name *</label>
                                                    <input
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        value={currentHoa?.name || ''}
                                                        onChange={(e) => setCurrentHoa({ ...currentHoa, name: e.target.value })}
                                                        required
                                                        type="text"
                                                        disabled={isReadOnly} // Disable if system-defined
                                                        readOnly={isReadOnly} // Make explicitly read-only
                                                    />
                                                     {isReadOnly && <small className="text-muted">System-defined HOAs cannot be renamed.</small>}
                                                    <div className="mt-1">
                                                        <span className="text-danger">{currentHoaError?.name}</span>
                                                    </div>
                                                </div>

                                                {/* Display flags (read-only) in edit mode for info */}
                                                {formType === 'edit' && (
                                                    <div className="col-md-6 mb-3 d-flex align-items-center">
                                                         <span className={`badge me-2 ${currentHoa?.is_system_defined ? 'bg-secondary' : 'bg-light text-dark'}`}>
                                                            {currentHoa?.is_system_defined ? 'System Defined' : 'User Defined'}
                                                         </span>
                                                         {currentHoa?.is_gst_head && (
                                                             <span className="badge bg-info">GST Account</span>
                                                         )}
                                                    </div>
                                                )}

                                                <div className="col-12 mt-3"> {/* Added mt-3 */}
                                                    <div className="text-end">
                                                        {formType === 'create' ? (
                                                            <>
                                                                <button className="btn btn-outline-primary me-2 btn-sm" type="button" onClick={() => saveAddHoaForm(false)} disabled={loading}>Save + Next</button>
                                                                <button className="btn btn-primary me-2 btn-sm" type="button" onClick={() => saveAddHoaForm(true)} disabled={loading}>Save + Exit</button>
                                                                <button className="d-none d-md-inline-block btn btn-danger btn-sm me-2" onClick={handleResetHoaForm} type="button" disabled={loading}>Reset</button>
                                                           
                                                            </>
                                                        ) : (
                                                            <>
                                                                <button className="btn btn-primary me-2 btn-sm" type="button" onClick={() => saveEditHoaForm(true)} disabled={loading || isReadOnly}>Update</button> {/* Disable update if read-only */}
                                                                 <button className="btn btn-secondary me-2 btn-sm" type="button" onClick={handleResetHoaForm} disabled={loading}>Reset</button>
                                                             
                                                            </>
                                                        )}
                                                        <button className="d-none  d-md-inline-block btn btn-light-reddit b-r-22 d-inline-flex-center" type="button" onClick={() => navigate('/franchisee_user/masters/hoas')} disabled={loading}>Go Back</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </>
    );
};

// **Component to wrap HoasForm for Edit route**
export const EditHoaPageWrapper = () => {
     const { id } = useParams();
     return <HoasForm formType="edit" currentHoaId={id} />;
};

// **Component to wrap HoasForm for Create route**
export const NewHoaPageWrapper = () => {
     return <HoasForm formType="create" currentHoaId={null} />;
};


export default HoasForm; // Keep default export if needed elsewhere, but use wrappers for routes